module.exports = __webpack_public_path__ + "static/media/moist.f56f2825.svg";